export default __webpack_public_path__ + "static/mac-17a5e3ccdd5e87696a59c6f3720d634a.png";